import apiClient from './client'

export const changePassword = (oldPassword: string, newPassword: string) =>
  apiClient.put('/account/password', { oldPassword, newPassword })
